export default "__VITE_ASSET__DKueklqf__"